import { useTexts } from '@/feature/lang';
import SamIcon from '@mui/icons-material/AutoAwesome';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip from '../Tooltip';
import { chatbotStyles } from './styles';

const StyledButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: theme.zIndex.speedDial,
  boxShadow: theme.shadows[6],
  ...chatbotStyles.button(theme),
}));

interface ChatbotButtonProps {
  onClick: () => void;
}

export const ChatbotButton = ({ onClick }: ChatbotButtonProps) => {
  const texts = useTexts().component.chatbot.chatbotButton;

  return (
    <Tooltip title={texts.tooltip} placement="left">
      <StyledButton
        onClick={onClick}
        aria-label="open conversation"
        size="large"
      >
        <SamIcon sx={{ fontSize: 24 }} />
      </StyledButton>
    </Tooltip>
  );
};
